import { ApplicationRef, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()));
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then((moduleRef) => {
    if (!environment.production) {
      const applicationRef = moduleRef.injector.get(ApplicationRef);
      const appComponent = applicationRef.components[0];
      enableDebugTools(appComponent);  
    }
  })
  .catch(err => console.log(err));

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

if (!window.fbq) {
  window.fbq = function (...args: any[]) {
    console.warn('Dummy fbq called with:', ...args);
  };
}